import { formatCopy } from '../../copy/format.js';
import copy from '../../copy/en/shell.json' with { type: 'json' };
import { Link } from "react-router";
import { useMe } from "../auth/MeProvider.js";
import { Badge } from "../components/ui/Badge.js";
import { Card } from "../components/ui/Card.js";
import { PageHeader } from "../components/ui/PageHeader.js";
import { navItemById, PHASES, type NavItem, type PhaseInfo } from "./navManifest.js";

/**
 * Consistent stand-in for sections whose real screens arrive later. Every
 * top-level nav item resolves to a page — nothing 404s.
 */
export function PlaceholderPage({ navId, phaseNumber }: { navId?: string; phaseNumber?: number }) {
  const { hasCap } = useMe();
  const item: NavItem | undefined = navId ? navItemById(navId) : undefined;
  const phase: PhaseInfo | undefined =
    phaseNumber !== undefined ? PHASES[phaseNumber] : item?.upcomingPhase !== undefined ? PHASES[item.upcomingPhase] : undefined;
  const title = item?.label ?? phase?.name ?? copy.PlaceholderPage.comingSoon;
  const isReports = item?.id === "reports";

  return (
    <>
      <PageHeader
        title={title}
        description={isReports ? copy.PlaceholderPage.reportingIsNotAvailableYet : copy.PlaceholderPage.thisSectionIsPlannedAndIsNot}
        actions={<Badge tone="neutral">{phase ? formatCopy(copy.PlaceholderPage.plannedPhase, { phase: phase.number }) : copy.PlaceholderPage.planned}</Badge>}
      />
      <div className="placeholder">
        <Card title={isReports ? copy.PlaceholderPage.reportingIsComingLater : copy.PlaceholderPage.continueYourWork}>
          <div className="stack">
            <ul className="placeholder__destinations">
              {isReports ? <li><Link to="/">{copy.PlaceholderPage.dashboard}</Link><span>{copy.PlaceholderPage.returnToCurrentActivity}</span></li> : <>
                {hasCap("view:all") ? <li><Link to="/">{copy.PlaceholderPage.signingDashboard}</Link><span>{copy.PlaceholderPage.agreementProgressAndRecentSignatures}</span></li> : null}
                {hasCap("practices:view") ? <li><Link to="/practices">{copy.PlaceholderPage.practices}</Link><span>{copy.PlaceholderPage.practiceDetailsProgramEnrollmentsAndActivity}</span></li> : null}
                {hasCap("documents:read") ? <li><Link to="/documents">{copy.PlaceholderPage.documents}</Link><span>{copy.PlaceholderPage.agreementChecklistsPdfsAndReviewHistory}</span></li> : null}
              </>}
            </ul>
          </div>
        </Card>
        {phase ? <details className="placeholder__roadmap"><summary>{copy.PlaceholderPage.plannedScope}</summary><p>{phase.goal}</p></details> : null}
      </div>
    </>
  );
}
